@if (
  {
    expanded: (expanded$ | async)!,
    items: (items$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'barrierefreiheit'"
    [label]="'Barrierefreier Ort'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    @if (context.expanded) {
      <fieldset id="barrierefreiheitFacette" class="now-input-group">
        <legend class="sr-only">Barrierefreier Ort</legend>
        <div class="now-radio-group" role="radiogroup">
          @for (item of context.items; track trackById(index, item); let index = $index) {
            <div class="form-check">
              <input
                id="barrierefreiheitFacette-option-{{ index }}"
                type="radio"
                name="barrierefreiheitFacette"
                [disabled]="!item.selected && !item.active"
                [value]="index"
                (click)="updateSelectedIds(item.key)"
                [checked]="item.selected"
              />
              <label
                for="barrierefreiheitFacette-option-{{ index }}"
                [ngStyle]="isNoMobile ? { width: 'max-content' } : null"
                >{{ item.label }}
              </label>
            </div>
          }
        </div>
      </fieldset>
    }
  </now-wbsuche-lib-basis-facette>
}
